import Vue from 'vue';
import AlertBox, { AlertPortal } from '@/mikan/_shared/lib/plugins/AlertBox';
import AlertBoxList from '@/mikan/_shared/components/organisms/AlertBoxList.vue';

Vue.use(AlertBox);

new Vue({
  name: 'AlertRoot',
  render(h) {
    return h('div', { staticClass: 'mikan-layout__alert' }, [
      h(AlertPortal, {
        props: {
          listComponent: AlertBoxList,
        },
      }),
    ]);
  },
}).$mount('#js-alert-list');
